import api from '@/api'

const state = {
  pickupAssignment: [],
  driverAssignment: [],
  pickupAssignmentDetail: {},
  nearByCouriers: []
}
const actions = {
  getPickupAssignment({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.assignment.pickupAssignmentList(params).then(
        response => {
          commit('setPickupAssignment', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPickupAssignmentDetail({ commit }, { pickupId }) {
    return new Promise((resolve, reject) => {
      api.assignment.pickupAssignmentDetail(pickupId).then(
        response => {
          commit('setPickupAssignmentDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getNearByCouriers({ commit }, { pickupId, params }) {
    return new Promise((resolve, reject) => {
      api.assignment.nearByCouriers(pickupId, params).then(
        response => {
          commit('setNearByCouriers', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  assignCourier({ _ }, { pickupId, payloads }) {
    return new Promise((resolve, reject) => {
      api.assignment.assignCourier(pickupId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDriverAssignment({ commit }, { partnerId, params }) {
    return new Promise((resolve, reject) => {
      api.assignment.driverAssignmentList(partnerId, params).then(
        response => {
          commit('setDriverAssignment', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setPickupAssignment(state, value) {
    state.pickupAssignment = value
  },
  setPickupAssignmentDetail(state, value) {
    state.pickupAssignmentDetail = value
  },
  setNearByCouriers(state, value) {
    state.nearByCouriers = value
  },
  setDriverAssignment(state, value) {
    state.driverAssignment = value
  }
}
const getters = {
  pickupAssignment: state => state.pickupAssignment,
  pickupAssignmentDetail: state => state.pickupAssignmentDetail,
  nearByCouriers: state => state.nearByCouriers,
  driverAssignment: state => state.driverAssignment
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
